import {useState, useEffect} from "react";
import rectangel from "../../Assets/svg/Rectangle 6294.svg";
import Rectangle from "../../Assets/svg/Rectangle 6295.svg";
import "./AboutUs.scss";
import Title from "../Title/Title";
import {toast} from "react-toastify";
import axios from "axios";
import {prefixUrl} from "../../Utils/utilsData";
import Loader from "../Loader/Loader";

function AboutUS() {
  const [data, setData] = useState({});
  const [dataFetched, setDataFetched] = useState(false);
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    if (!dataFetched) {
      axios
        .get(`${prefixUrl()}/aboutUS.php`)
        .then((res) => {
          if (res.data.status) {
            setData(res.data.output[0]);
            setDataFetched(true);
            setIsLoad(true)
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [dataFetched]);
  let aboutText = data?.value && data?.value?.replace(/\n/g, "<br>");

  return (
    <>
      {isLoad ?
        <div className="AboutUs">
          <div className="columnRightAboutUs">
            <Title englishTitle={data.titleEnglish} title={data.titlePersian}/>
            <div className="paragraphAboutUs">
              <p dangerouslySetInnerHTML={{__html: aboutText}}/>
            </div>
          </div>
          <div className="LeftAboutUs">
            <div className="ImageBackAboutUs">
              <img src={data?.image} alt="BackgroundImage"/>
            </div>
          </div>
        </div>
        : <Loader/>}
    </>
  );
}

export default AboutUS;
